import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "./redux/heatmapSaga";
import SecondaryCategory from "./smartComponents/secondaryCategory";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import Heatmap from "../../views/Heatmap";
import "./HeatmapModule.css";

const HeatmapModule = () => {
  const dispatch = useDispatch();
  const { fetchHeatmapData } = actionCreators;
  const { filtersDirty, isLoading } = useSelector((state) => state.retentionHeatmap);
  const { useSecondaryCategories, sourceType, short_url, organization_id } = useSelector(
    (state) => state.commonReducer.commonProps
  );

  const renderUpdateBtn = () => {
    if (filtersDirty && !isLoading) {
      return (
        <button
          className="submit override-submit"
          onClick={() => dispatch(actionCreators.updateHeatmapData())}
        >
          Update
        </button>
      );
    }
  };

  const renderResetBtn = () => {
    if (filtersDirty && !isLoading) {
      return (
        <button
          className="submit reset override-submit"
          onClick={() => dispatch(actionCreators.resetFilters())}
        >
          Reset
        </button>
      );
    }
  };

  return (
    <SectionToggle
      maxHeight="auto"
      autoHeight
      title="Membership Retention Heatmap"
      customClass="class-check-in-heatmap withSticky"
      content={
        <>
          <div id="react-heatmap-overlay"></div>
          <div className="chart-holder">
            {sourceType === "clubready" ? (
              <div id="heatmap-edit-selection-bar" className="edit-selections-bar">
                <div className="select-box-no-width">
                  <p>{useSecondaryCategories ? "Secondary Category" : "Category"}</p>
                  <SecondaryCategory />
                </div>
                {renderUpdateBtn()}
                {renderResetBtn()}
              </div>
            ) : null}
            <Heatmap
              stateName="retentionHeatmap"
              params={{ short_url, organization_id }}
              sourceType={sourceType}
              fetchHeatmapData={fetchHeatmapData}
            />
          </div>
        </>
      }
    />
  );
};

export default React.memo(HeatmapModule);
